module.exports = "<div class=\"row offline-row\">\r\n  <div class=\"col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3 col-xs-10 col-xs-offset-1\">\r\n    <p >You are not connected to internet.</p>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/offline/offline.component.html
// module id = ../../../../../src/app/offline/offline.component.html
// module chunks = 2